const route = 'https://genesisorthodontics.com/wp-json'

const api = () => {
  return route
  // try {
  //   return (document.location.protocol === 'https:' ? 'https:' : 'http:') + route
  // } catch (e) {
  //   return 'https://' + route
  // }
}

export default api()



// WEBPACK FOOTER //
// ./src/shared/api/api.js